import type { OrgFeature } from '@risksmart-app/modules/src/index';
import { createContext } from 'react';

/**
 * Feature-flag overrides for e2e test organisations (ENG-539).
 *
 * Non-null ONLY when the signed-in organisation is marked
 * `Meta.isE2eTestOrg: true` (admin-only writable — no app role can update
 * `auth_organisation.Meta`). The value is the org's seeded `Meta.features`
 * list, which the e2e suite's `configureOrganisation` writes per test.
 *
 * `useIsFeatureFlagEnabled` treats a non-null value as AUTHORITATIVE —
 * membership = on, absence = off — instead of evaluating the OpenFeature
 * provider. Live providers (Datadog on deployed envs) cannot be seeded
 * per-test: config propagation is slow and parallel Playwright workers would
 * race on the shared org-global targeting rules, so e2e orgs keep the legacy
 * Meta.features semantics the regression pack was written against.
 *
 * `null` (the default, and the value for every real organisation) means "no
 * override" — flags resolve from the registered OpenFeature provider.
 */
export const E2eFlagOverridesContext = createContext<OrgFeature[] | null>(null);
